import { render, staticRenderFns } from "./StaffsDialog.vue?vue&type=template&id=4a42c3dc&"
import script from "./StaffsDialog.vue?vue&type=script&lang=js&"
export * from "./StaffsDialog.vue?vue&type=script&lang=js&"
import style0 from "./StaffsDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports